import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CoffeeRustAlertResponse,
  CoffeeRustAlertPaginatedResponse,
} from '../../models/coffee-rust-alert';
import { CoffeeRustAlertAdapter } from '../../adapters/coffee-rust-alert';
import { environment } from '@env/environment';

const BASE_URL =
  environment.apiBaseUrl + '/decision-support/coffee-rust/hinnah';

/**
 * Serviço para acesso à API de alertas de ferrugem do café (Modelo Hinnah)
 */
@Injectable({
  providedIn: 'root',
})
export class CoffeeRustAlertApiService {
  constructor(private readonly http: HttpClient) {}

  /**
   * Busca todos os alertas ativos de ferrugem do café
   * @returns Observable com resposta contendo alertas favoráveis e não favoráveis
   */
  getActiveAlerts(): Observable<CoffeeRustAlertResponse> {
    return this.http.get<{ data: any }>(`${BASE_URL}/active-alerts`).pipe(
      map((response: any) => {
        if (response?.data) {
          return CoffeeRustAlertAdapter.fromApiResponse(response.data);
        }
        throw new Error('Resposta da API inválida');
      }),
    );
  }

  /**
   * Busca alertas ativos de ferrugem do café com paginação
   * @param page Número da página (padrão: 0)
   * @param size Tamanho da página (padrão: 10)
   * @param sortField Campo para ordenação (opcional)
   * @param sortDirection Direção da ordenação - asc ou desc (opcional)
   * @returns Observable com resposta paginada
   */
  getActiveAlertsPaginated(
    page: number = 0,
    size: number = 10,
    sortField?: string,
    sortDirection?: string,
  ): Observable<CoffeeRustAlertPaginatedResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    // Adiciona dois parâmetros de ordenação separados se fornecido
    // A API espera: ?sort=stationName&sort=asc
    if (sortField && sortDirection) {
      params = params.append('sort', sortField).append('sort', sortDirection);
    }

    return this.http
      .get<{ data: any }>(`${BASE_URL}/active-alerts/paginated`, { params })
      .pipe(
        map((response: any) => {
          if (response?.data) {
            return CoffeeRustAlertAdapter.fromApiPaginatedResponse(
              response.data,
            );
          }
          throw new Error('Resposta da API inválida');
        }),
      );
  }
}
